/**
 * Shared Material-UI sx styles for React Admin Datagrids
 *
 * This module provides consistent styling across all List pages in the application.
 * Import and use these styles to maintain a uniform look and feel.
 */

// Standard Datagrid styling used across most List pages
// Features: compact layout, small fonts, hidden checkboxes and expand icons
export const standardDataGridSx = {
    "& .RaDatagrid-headerRow": {
        borderLeftColor: 'white',
        borderLeftWidth: 5,
        borderLeftStyle: 'solid',
        fontSize: '0.75rem !important'
    },
    "& .RaDatagrid-headerCell": {
        padding: '1px 4px 1px 2px;',
        whiteSpace: 'nowrap',
        fontWeight: 'bold',
        fontSize: '0.75rem !important'
    },
    "& .RaDatagrid-rowCell": {
        padding: '1px 4px 1px 2px;',
        whiteSpace: 'nowrap',
        fontSize: '0.75rem !important'
    },
    "& .RaDatagrid-row": {
        fontSize: '0.75rem !important'
    },
    "& .RaDatagrid-tbody": {
        fontSize: '0.75rem !important'
    },
    "& .MuiTableCell-paddingCheckbox": {
        display: 'none'
    },
    "& .RaDatagrid-expandIconCell": {
        display: 'none'
    },
};

// Datagrid style with striped rows (even/odd background colors)
// Used in Order Reconciliation page
export const stripedDataGridSx = {
    ...standardDataGridSx,
    "& .RaDatagrid-rowEven": {
        backgroundColor: '#eee',
    },
    "& .RaDatagrid-rowOdd": {
        backgroundColor: '#fff',
    },
};

// Datagrid style for expanded row details with more horizontal spacing
// Used in Order List expanded row details
export const expandedRowDataGridSx = {
    "& .MuiTableCell-paddingCheckbox": {
        display: 'none'
    },
    "& .RaDatagrid-expandIconCell": {
        display: 'none'
    },
    "& .MuiTableCell-root": {
        padding: '6px 24px',
        whiteSpace: 'normal',
    },
    "& .RaDatagrid-headerCell": {
        padding: '6px 24px',
    },
    "& .RaDatagrid-rowCell": {
        padding: '6px 24px',
    },
};

// Style for Order List main table with custom expand header visibility
// Note: Does NOT hide expandIconCell because rows need expand arrows
export const orderListDataGridSx = {
    "& .RaDatagrid-headerRow": {
        borderLeftColor: 'white',
        borderLeftWidth: 5,
        borderLeftStyle: 'solid',
        fontSize: '0.75rem !important'
    },
    "& .RaDatagrid-headerCell": {
        padding: '1px 4px 1px 2px;',
        whiteSpace: 'nowrap',
        fontWeight: 'bold',
        fontSize: '0.75rem !important'
    },
    "& .RaDatagrid-rowCell": {
        padding: '1px 4px 1px 2px;',
        whiteSpace: 'nowrap',
        fontSize: '0.75rem !important'
    },
    "& .RaDatagrid-row": {
        fontSize: '0.75rem !important'
    },
    "& .RaDatagrid-tbody": {
        fontSize: '0.75rem !important'
    },
    "& .MuiTableCell-paddingCheckbox": {
        display: 'none'
    },
    "& .RaDatagrid-expandHeader": {
        visibility: 'hidden'
    },
    "& .RaDatagrid-rowEven": {
        backgroundColor: '#eee',
    },
    "& .RaDatagrid-rowOdd": {
        backgroundColor: '#fff',
    },
};
